import { Form, Input, Modal, message } from 'antd';
import 'moment/locale/es';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { useTranslation } from 'react-i18next';
import { authFetch } from '../../../../../common/request/authFetch';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';


export const AddClientWebModal = ({
    url,
    onFinish,
}: any) => {

    //const [errorMessage, setErrorMessage] = useState('');    

    const { t } = useTranslation();

    const [form] = Form.useForm();
    const { projectGroup } = useAuth();

    const onFormFinish = async (values: any) => {
        await authFetch(`${process.env.REACT_APP_API}/client/web/projects/${projectGroup.project}?url=${values.url}`,{ method: 'POST' }
        )
        .then((res) => {
            if (res) {
                //setErrorMessage('')
                onFinish();
            } else {
                message.error('Error al subir la url de la web');
            }
        })
    }

    return (

        <Modal
            open={true}
            onOk={() => form.submit()}
            onCancel={onFinish}
            {...modalPanelStyles}
            title={
                <DrawerPanelTitle
                    title={<>Generar nueva <b>clave</b></>}
                    isProject={true}
                />
            }
        >
            <i>Añade el dominio con el que usarás la clave</i>
            <Form 
                initialValues={{url: url}}
                layout='vertical' form={form} onFinish={onFormFinish} >

                <Form.Item	rules={[{ required: true }]} name={`url`}>
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    )
}
